<template>
  <div class="app-nav">
    <div class="col-lg-3 col-md-4 col-sm-4 col-xs-12 xs-hidden">
      <h4 class="nav-name">{{pathName[pathName.length-1]}}</h4>
    </div>
    <div class="col-lg-9 col-sm-8 col-md-8 col-xs-12">
      <ol class="breadcrumb">
        <li v-for="(item, index) in pathName" :key="index">
          <span>{{item}}</span>
        </li>
      </ol>
    </div>
  </div>
</template>
<script>
  export default{
    data () {
      return {
        pathKey: '',
        pathName: []
      };
    },
    watch: {
      $route() {
        this.getMenu();
      }
    },
    mounted(){
      this.getMenu();
    },
    methods: {
      getMenu() {
        const bread = [];
        for (let index = 0; index < this.$route.matched.length; index++) {
          const item = this.$route.matched[index];
          if(item.meta.hasOwnProperty('title')) {
            bread.push(item.meta.title);
          }
        }
        this.pathName = bread;
      }
    }
  }
</script>
<style scoped>
  .app-nav {
    height: 46px;
    background: #ffffff;
    padding: 4px 9px 4px 10px;
  }

  .nav-name {
    color: #313131;
    font-family: Rubik, sans-serif;
    margin: 10px 0;
    font-weight: 300;
  }

  .breadcrumb {
    float: right;
    background: 0 0;
    margin-bottom: 0;
    padding: 0;
    margin-top: 8px;
  }

  @media screen and (max-width: 768px) {
    #app .breadcrumb {
      padding: 8px 10px;
    }

    .xs-hidden {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/utility/navigation-path.vue